<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-cultura') {
            next({ name: 'agro-cultura-list' });
        } else if (to.name == 'ven-cultura') {
            next({ name: 'ven-cultura-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-cultura') {
            this.$router.push({ name: 'agro-cultura-list' });
        } else if (this.$route.name == 'ven-cultura') {
            this.$router.push({ name: 'ven-cultura-list' });
        }
    },
};
</script>
